import { cva } from 'class-variance-authority'
import PropTypes from 'prop-types'

const variants = cva(
	/* base style */
	'absolute p-2 text-xs transition-all scale-0 rounded group-hover:scale-100 min-w-max',
	{
		variants: {
			position: {
				top: 'bottom-6',
				bottom: 'top-6',
				left: 'right-10',
				right: 'left-10'
			},
			theme: {
				dark: 'bg-gray-800 text-white',
				light: 'bg-white text-gray-800 border border-gray-200 shadow-lg'
			}
		},
		defaultVariants: {}
	}
)

/**
 * @typedef TooltipProps
 * @property {string} [className]
 * @property {'top' | 'bottom' | 'left' | 'right'} [position] default is 'top'
 * @property {'dark' | 'light'} [theme] default is 'dark'
 */

/**
 * @param {TooltipProps} props
 */
const Tooltip = ({ className, position, message, children, theme = 'dark' }) => {
	if (!message) return children

	return (
		<div className="relative flex group w-fit">
			{children}
			<span className={variants({ className, position, theme })}>{message}</span>
		</div>
	)
}

Tooltip.propTypes = {
	className: PropTypes.string,
	message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
	children: PropTypes.node,
	theme: PropTypes.oneOf(['dark', 'light'])
}

Tooltip.defaultProps = {
	position: 'top',
	theme: 'dark'
}

export default Tooltip
